export class UIAppConfig {
  agGridKey: string;
  walkMeSrc: string;
  logToSiteUsageTracker: boolean;
  siteTrackerUrl: string;
  siteTrackerSiteId: number;
  leftNavLinks: LeftNavLinks;
  currentTheme: ICurrentTheme;
  features: { [key: string]: boolean };
  readonly defaultPageSize: number = 50;
}

export class LeftNavLinks {
  legacyAppLoginUrl: string;
  downloadResourcesUrl: string;
  quickReferenceGuideUrl: string;
  selfInstallGuideUrl: string;
  customerServiceUrl: string;
}

export class CurrentTheme implements ICurrentTheme {
  get themeId(): number {
    return this.itheme.themeId;
  }
  get themeName(): string {
    return this.itheme.themeName;
  }
  get productName(): string {
    return this.itheme.productName;
  }
  get themePathSegment(): string {
    return this.itheme.themePathSegment;
  }
  get unrecognizedPathSegment(): string {
    return this.itheme.unrecognizedPathSegment;
  }
  get colors(): string {
    return this.itheme.colors;
  }
  get font(): string {
    return this.itheme.font;
  }
  get logoUrl(): string {
    return this.itheme.logoUrl;
  }
  get customerLogoHyperlink(): string {
    return this.itheme.customerLogoHyperlink;
  }

  get LogoUrlPath(): string {
    if (this.themeId === 0 || this.logoUrl === null || this.logoUrl === '') {
      return 'assets/images/Dashboard_logo@3x.png';
    } else {
      let dtStamp = new Date();
      return `${this.logoUrl}?v=${dtStamp.getTime().toString()}`;
    }
  }

  get heartbeatLogoUrlPath(): string {
    return this.LogoUrlPath;
  }

  constructor(private itheme: ICurrentTheme) {}

  // getLogoColor(themeId: number): string {
  //   if (themeId === 0) {
  //     return '';
  //   } else {
  //     return this.colors;
  //   }
  // }
}

export interface ICurrentTheme {
  themeId: number;
  themeName: string;
  /**
   * What this theme calls the product, shown in the browser tab title. Absent on an unthemed visit,
   * where the app falls back to its default brand - see AppTitleStrategy.
   */
  productName?: string;
  /**
   * Leading path segment every route is pinned under, e.g. 'acme' in /acme/dashboard.
   * Resolved server-side by GetuiAppConfig and null unless the request URL was genuinely
   * under a theme slug - see ThemeRouter. Only that endpoint populates it; get-theme-by-url
   * leaves it undefined, so read it at bootstrap, not from a later themeConfig$ emission.
   */
  themePathSegment?: string;
  /**
   * A leading path segment that is neither an app route nor a real theme - a typo or a stale
   * link. main.ts strips it from the address bar before Angular routes, so the session does not
   * run under a prefix that means nothing. See ThemeRouter.
   */
  unrecognizedPathSegment?: string;
  colors: string;
  font: string;
  logoUrl: string;
  customerLogoHyperlink: string;
}
